var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "16 16 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_7",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00ceff",
    floodOpacity: 0.275
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_6",
    x: 3,
    y: 3,
    width: 67,
    height: 67,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00ceff",
    floodOpacity: 0.275
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 36.032,
    height: 36.032,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(-377.5 6.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(396 12)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M36.032,18.016A18.016,18.016,0,1,1,18.016,0,18.016,18.016,0,0,1,36.032,18.016",
    fill: "#00ceff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M125.178,251.809v0c1.79,0,3.58.017,5.369-.005a3.067,3.067,0,0,0,2.957-2.513,14.1,14.1,0,0,0,.078-2.109.928.928,0,1,0-1.854,0c-.009.432,0,.863,0,1.3a1.335,1.335,0,0,1-1.463,1.477q-5.085,0-10.17,0a1.334,1.334,0,0,1-1.463-1.477c0-.474.013-.948-.013-1.421a.908.908,0,0,0-.9-.846.9.9,0,0,0-.926.784,11.729,11.729,0,0,0,.033,2.143,3.093,3.093,0,0,0,3.144,2.676c1.737.012,3.474,0,5.211,0",
    transform: "translate(-107.155 -225.955)",
    fill: "#08231b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M156.853,98.412a1.2,1.2,0,0,1,.7,1.248c-.018,2.737-.008,5.475-.008,8.212v.423c.127-.121.207-.194.283-.271l2.769-2.769a.919.919,0,0,1,.987-.239.786.786,0,0,1,.6.735,1.176,1.176,0,0,1-.24.775c-1.745,1.783-3.517,3.54-5.282,5.3a.277.277,0,0,1-.073.032c-.04-.036-.088-.074-.131-.117q-2.568-2.568-5.135-5.138a.926.926,0,0,1,.271-1.575.939.939,0,0,1,1.063.266c.9.9,1.8,1.8,2.7,2.705a2.263,2.263,0,0,1,.2.278l.1-.05V107.9c0-2.748.01-5.5-.008-8.243a1.209,1.209,0,0,1,.695-1.248Z",
    transform: "translate(-138.578 -90.319)",
    fill: "#08231b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M125.178,251.809c-1.737,0-3.474.01-5.211,0a3.093,3.093,0,0,1-3.144-2.676,11.729,11.729,0,0,1-.033-2.143.9.9,0,0,1,.926-.784.908.908,0,0,1,.9.846c.026.472.01.947.013,1.421a1.334,1.334,0,0,0,1.463,1.477q5.085,0,10.17,0a1.335,1.335,0,0,0,1.463-1.477c0-.432-.006-.864,0-1.3a.928.928,0,1,1,1.854,0,14.1,14.1,0,0,1-.078,2.109,3.067,3.067,0,0,1-2.957,2.513c-1.789.023-3.579.005-5.369.005v0",
    transform: "translate(-107.155 -225.955)",
    fill: "#08231b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.d2051eb28a1dfadc283a47b7c70851ab.svg";
export { ForwardRef as ReactComponent };